//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  OnDestroy,
  Signal,
} from "@angular/core";

// //local imports
import { Messenger } from "@app/shared";
import {
  ModuleNavigatedMessage,
  ThemeService,
} from "@app/core";

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderComponent implements OnDestroy {
      
  public isDark = computed(() => this.themeService.theme() === "dark");

  public moduleNavigated: Signal<ModuleNavigatedMessage>;
  public currentHeader = computed(() => this.moduleNavigated()?.header);
 

  constructor(
    private themeService: ThemeService,
    private messenger: Messenger) {
      this.moduleNavigated = this.messenger.getSignal(ModuleNavigatedMessage);
  }


  public toggleTheme() {
    this.themeService.toggleTheme();
  }
  
  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
  
}



